import type {
	AtlassianTeamUpdateArchiveAction,
	AtlassianTeamUpdateArchiveHydratedAction,
	TeamV2,
} from '../types';

import { toTeamAri } from './ari';

export function buildHydratedArchiveTeamActions(
	actions: AtlassianTeamUpdateArchiveAction[],
	hydratedTeams: Map<string, TeamV2>,
): AtlassianTeamUpdateArchiveHydratedAction[] {
	return actions
		.map((action) => {
			const hydratedData = hydratedTeams.get(toTeamAri(action.data.teamId));
			if (hydratedData == null) return null;
			return {
				...action,
				data: {
					...action.data,
					...hydratedData,
				},
			};
		})
		.filter((action): action is AtlassianTeamUpdateArchiveHydratedAction => action != null);
}

const collator = new Intl.Collator(undefined, {
	sensitivity: 'base',
	numeric: true,
});

/**
 * Returns a new array of hydrated actions sorted by display name (case-insensitive, numeric-aware).
 * Teams with a display name come before teams without one. Ties break on teamId.
 */
export function sortHydratedArchiveTeamActions(
	actions: AtlassianTeamUpdateArchiveHydratedAction[],
): AtlassianTeamUpdateArchiveHydratedAction[] {
	return [...actions].sort((a, b) => {
		const nameA = a.data.displayName?.trim() || '';
		const nameB = b.data.displayName?.trim() || '';

		const hasNameA = nameA.length > 0;
		const hasNameB = nameB.length > 0;

		if (hasNameA !== hasNameB) {
			return hasNameA ? -1 : 1;
		}

		return (
			collator.compare(nameA, nameB) || collator.compare(a.data.teamId || '', b.data.teamId || '')
		);
	});
}
